import { BreadCrumbs, HomeIcon } from '@isdd/idsk-ui-kit/index'
import { useTranslation } from 'react-i18next'

import { getCiHowToBreadCrumb, useCiListPageHeading } from '@/componentHelpers/ci'
import { MainContentWrapper } from '@/components/MainContentWrapper'
import { CiListContainer } from '@/components/containers/CiListContainer'
import { POFilterData } from '@/components/entities/projekt/Filters/FilterPO'
import { POView } from '@/components/views/ci/PO/POView'

const POIsPOListPage = () => {
    const { t } = useTranslation()
    const PO = 'PO'
    const PO_IS_PO = 'PO_IS_PO'
    const defaultFilterValues: POFilterData = {
        Gen_Profil_nazov: '',
        Gen_Profil_kod_metais: '',
        EA_Profil_PO_kategoria_osoby: ['c_kategoria_osoba.1'],
        EA_Profil_PO_typ_osoby: [],
        EA_Profil_PO_je_kapitola: undefined,
        evidence_status: ['DRAFT'],
    }
    const { getHeading } = useCiListPageHeading(t(`titles.${PO_IS_PO}`) ?? '', t)
    return (
        <>
            <BreadCrumbs
                withWidthContainer
                links={[
                    { label: t('breadcrumbs.home'), href: '/', icon: HomeIcon },
                    ...getCiHowToBreadCrumb(PO_IS_PO, t),
                    { label: getHeading() ?? '', href: `/ci/${PO_IS_PO}` },
                ]}
            />
            <MainContentWrapper>
                <CiListContainer<POFilterData>
                    entityName={PO}
                    POType={PO_IS_PO}
                    defaultFilterValues={defaultFilterValues}
                    ListComponent={(props) => <POView {...props} />}
                />
            </MainContentWrapper>
        </>
    )
}

export default POIsPOListPage
